module.exports = __webpack_public_path__ + "static/img/05.d01e6af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour5/05.jpg
// module id = M5lb
// module chunks = 0